import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './store/store';
import Notes from './Notes';

ReactDOM.createRoot(document.getElementById('notes-react-app')).render(
	<Provider store={store}>
		<Notes />
	</Provider>
);
